<template>
	<vx-card>
		<div class="vx-row"
			v-if="
					$store.state.auth.role === 'manager' || $store.state.auth.role === 'admin'
					|| $store.state.auth.role === 'supervisor'
				"
		>
			<div class="vx-col pt-2 pb-4"><strong>{{ $t('informationAboutOrder') }}</strong></div>
			<div @click="enableEditing" 
				style="cursor: pointer !important;"
				class="vx-col pt-2 pb-4"
			>{{ $t('editInformationAboutOrder') }}</div>
			<div @click="openComment" 
				style="cursor: pointer !important;"
				class="vx-col pt-2 pb-4"
			>{{ $t('commentAboutOrder') }}
				<span
                    v-if="countOrderComments > 0"
                    class="status text-sm"
                >
                    {{ countOrderComments }}
                </span>
			</div>
			<div  @click="openTask" 
				style="cursor: pointer !important;"
				class="vx-col pt-2 pb-4"
			>{{ $t('taskAboutOrder') }}
				<span
                    v-if="countOrderTasks.count > 0"
                    class="status text-sm"
                    :class="{ markedDelay: countOrderTasks.delay > 0 }"
                >
                    {{ countOrderTasks.count }}
                </span>
			</div>
		</div>
		<hr class="mb-4"
			v-if="
					$store.state.auth.role === 'manager' || $store.state.auth.role === 'admin' 
					|| $store.state.auth.role === 'supervisor'
				"
		>
		<table class="order__details">
			<tbody>
			<tr v-if="['admin', 'manager', 'supervisor'].indexOf($store.state.auth.role) !== -1">
				<td><b>{{ $t('site') }}</b></td>
				<td>
					<div								
						class="text-sm frsColorBackSite"
						:style="`background-color: ${model.client.highlightingBackground}; color: ${model.client.highlightingText};`"
					>
						{{ websiteName }}
					</div>
				</td>
			</tr>
			<tr v-if="['admin', 'manager', 'supervisor'].indexOf($store.state.auth.role) !== -1">
				<td><b>{{ $t('client') }}</b></td>
				<td>
					<RouterLink :to="`/${pathToClient}/${clientId}`">
						{{ clientName }}
					</RouterLink>
				</td>
			</tr>
			<tr v-if="['admin', 'manager', 'supervisor'].indexOf($store.state.auth.role) !== -1">
				<td><b>{{ $t('clientsEmail') }}</b></td>
				<td class="flex-auto">
					<RouterLink :to="`/${pathToClient}/${clientId}`">
						<div :class="{ 'frsColorBackEmailSpam': clientEmailSpam || clientEmailError}">{{ clientEmail }}</div>
						<div v-if="clientEmailSpam" style="color:red;">{{ $t('emailSpamList') }}</div>
						<div v-else-if="clientEmailError" style="color:red;">{{ $t('emaiErrorlList.'+model.client.email_error) }}</div>
					</RouterLink>
				</td>
			</tr>
			<tr v-if="['admin', 'manager', 'supervisor'].indexOf($store.state.auth.role) !== -1 
					&& clientEmailSecondary !== null 
					&& clientEmailSecondary != '' 
					&& clientEmailSecondary != '---'"
			>
				<td><b>{{ $t('clientsEmailSecondary') }}</b></td>
				<td class="flex-auto">
					<RouterLink :to="`/${pathToClient}/${clientId}`">
						<div :class="{ 'frsColorBackEmailSpam': clientEmailSecondarySpam }">{{ clientEmailSecondary }}</div>
						<div v-if="clientEmailSecondarySpam" style="color:red;">{{ $t('emailSpamList') }}</div>
					</RouterLink>
				</td>
			</tr>
			<tr v-if="['admin', 'manager', 'supervisor'].indexOf($store.state.auth.role) !== -1 && clientPhone !== null && clientPhone != '' && clientPhone != '---'">
				<td><b>{{ $t('clientsPhone') }}</b></td>
				<td>
					<RouterLink :to="`/${pathToClient}/${clientId}`">
						{{ clientPhone }}
					</RouterLink>
				</td>
			</tr>

			<tr
				v-if="model.utmSource !== null && model.utmSource != '' 
							&& $store.state.auth.role === 'admin'
							&& model.utmSource != '---' && model.utmSource != undefined"
			>
				<td><b>{{ $t('utmSource') }}</b></td>
				<td>
						{{ model.utmSource }}
				</td>		
			</tr>
			<tr
				v-if="model.utmMedium !== null && model.utmMedium != '' 
							&& $store.state.auth.role === 'admin'
							&& model.utmMedium != '---' && model.utmMedium != undefined"
			>
				<td><b>{{ $t('utmMedium') }}</b></td>
				<td>
						{{ model.utmMedium }}
				</td>		
			</tr>
			<tr
				v-if="model.utmCampaign !== null && model.utmCampaign != '' 
							&& $store.state.auth.role === 'admin'
							&& model.utmCampaign != '---' && model.utmCampaign != undefined"
			>
				<td><b>{{ $t('utmCampaign') }}</b></td>
				<td>
						{{ model.utmCampaign }}
				</td>		
			</tr>
			<tr class="vx-row"
				v-if="model.utmTerm !== null && model.utmTerm != '' 
							&& $store.state.auth.role === 'admin'
							&& model.utmTerm != '---' && model.utmTerm != undefined"
			>
				<td><b>{{ $t('utmTerm') }}</b></td>
				<td>
						{{ model.utmTerm }}
				</td>		
			</tr>

			<tr>
				<td><b>{{ $t('workName') }}</b></td>
				<td>{{ model.name }}</td>
			</tr>
			<tr>
				<td><b>{{ $t('workLanguage') }}</b></td>
				<td>
					{{ $getDeep(model.language, languages) }}
				</td>
			</tr>
			<tr>
				<td><b>{{ $t('subjectArea') }}</b></td>
				<td>
					{{ $getDeep(model.subject, subjects) }}
				</td>
			</tr>
			<tr v-if="['admin', 'manager'].indexOf($store.state.auth.role) !== -1">
				<td><b>{{ $t('qualityLevel') }}</b></td>
				<td>{{ $getDeep(model.quality_level, levels) }}</td>
			</tr>
			<tr>
				<td><b>{{ $t('dueDate') }}</b></td>
				<td>{{ model.due_date }}</td>
			</tr>
			<tr>
				<td><b>{{ $t('dueTimeAuthor') }}</b></td>
				<td>{{ model.dueTimeAuthor }}</td>
			</tr>
			<tr v-if="['admin', 'manager', 'supervisor'].indexOf($store.state.auth.role) !== -1">
				<td><b>{{ $t('paymentMethod') }}</b></td>
				<td>
					{{ $getDeep(model.pay_type, payTypes, "label") }}
				</td>
			</tr>
			<tr v-if="model.files">
				<td><b>{{ $tc('attachedFiles', model.files.length) }}</b></td>
				<td>
					<div v-for="(file, index) in model.files" :key="index">
						<a
							target="_blank"
							:href="file.url"
							:title="file.name"
						>
						{{ $t('fileNumbering') }} {{ index+1 }}
							<!-- {{ file.name }} -->
						</a>
						<span v-if="file.date != ''"> - {{ file.date }}</span>
						<br>
					</div>
				</td>
			</tr>
			<tr>
				<!-- <td><b>{{ $t('comment') }}</b></td> -->
				<td colspan="2" class="break-words hyphens-auto text-justify">
					<hr class="w-full">
					<b>{{ $t('comment') }}</b>
					<div style="" 
					 v-html="model.description">

					</div>
					<hr class="w-full">

				</td>
			</tr>
			<template
				v-for="(work, index) in stagesList"
			>
				<tr :key="index + 'border'"
					class="top-border">
					<td class="top-border__container" colspan="2">
						<div class="top-border__line"></div>
					</td>
				</tr>
				<tr :key="index">
					<td></td>
					<td><b>{{ $t('stageNumberInOrder') }} {{ index+1 }}</b></td>
				</tr>
				<tr :key="index + 'type'">
					<td><b>{{ $t('workType') }}</b></td>
					<td>
						{{ $getDeep(work.work_type_id, works) }}
					</td>
				</tr>
				<tr :key="index + 'pages'">
					<td><b>{{ $t('pagesAmount') }}</b></td>
					<td>
						{{ work.pages_number }}
					</td>
				</tr>
				<tr :key="index + 'paymentMilestone'">
					<td><b>{{ $t('paymentStage') }}</b></td>
					<td>
						<span
							:class="`${$getStatusPaymentMilestoneColor(work.paymentMilestone)} status`"
						>
							{{ $getStatusPaymentMilestone(work.paymentMilestone) }}
						</span>
					</td>
				</tr>
				<tr :key="index + 'due_date'">
					<td><b>{{ $t('dueDate') }}</b></td>
					<td>
						<strong>{{ getDate(work.due_date) }}</strong>
					</td>
				</tr>
				<tr :key="index + 'status'">
					<td><b>{{ $t('status') }}</b></td>
					<td>
						<span
							:class="`${$getStatusColor(work.status)} status`"
						>
							{{ $getStatus(work.status) }}
						</span>
					</td>
				</tr>
				<tr :key="index + 'files'">
					<td><b>{{ $t('files') }}</b></td>
					<td>
						<span
							v-if="work.files.length < 1"
						>
							{{ $t('filesAreNotUploaded') }}
						</span>
						<div 
							v-if="work.files.length > 0"
							v-for="(file, index) in work.files" :key="index"
						>
							<a
								target="_blank"
								:href="file.url"
								:title="file.name"
							>
								{{ $t('fileNumbering') }} {{ index+1 }}
							</a>
							<br>
						</div>
					</td>
				</tr>

				<!-- <tr :key="index + 'files'">
					<td colspan="2">
						<div class="stage__files">
							<div
								v-for="(file, fileIndex) in work.files"
								:key="fileIndex"
								class="stage__file"
							>
								<FileNameView
									:orderId="orderId"
									:url="file.url"
									:fileIndex="fileIndex"
									@fileDeleted="updateModel"
								/>
							</div>
						</div>
					</td>
				</tr> -->

			</template>
			</tbody>
		</table>
	</vx-card>
</template>

<script>
import databaseManager from '../../mixins/databaseManager';
import notifier from "@/mixins/notifier";
import FileNameView from "@/views/Tickets/FileNameView";

export default {
	name: "CardTicketView",
	props: {
		model: 		{ default: () => ({}) },
		levels:		{ default: () => [] },
		subjects: 	{ default: () => [] },
		works:		{ default: () => [] },
		languages:	{ default: () => [] },
		payTypes:	{ default: () => [] },
		stages:		{ default: () => [] },
		countOrderComments:     { default: null },
		countOrderTasks:     { default: null },
	},
	components: {
		FileNameView,
	},
	computed: {
		clientId() {
			if(!this.model.client) return "---";
			return this.model.client.id;
		},
		clientName() {
			if(!this.model.client) return "---";
			return this.model.client.full_name !== ""
				? this.model.client.full_name : "---";
		},
		clientPhone() {
			if(!this.model.client) return "---";
			return this.model.client.phone !== ""
				? this.model.client.phone : "---";
		},
		clientEmail() {
			if(!this.model.client) return "---";
			return this.model.client.email !== ""
				? this.model.client.email : "---";
		},
		clientEmailSpam() {
			if(!this.model.client) return false;
			return this.model.client.email_spam !== ""
				? this.model.client.email_spam : false;
		},
		clientEmailError() {
			if(!this.model.client) return false;
			return this.model.client.email_error !== ""
				? true : false;
		},
		clientEmailSecondary() {
			if(!this.model.client) return null;
			return this.model.client.email_secondary !== ""
				? this.model.client.email_secondary : "---";
		},
		clientEmailSecondarySpam() {
			if(!this.model.client) return false;
			return this.model.client.email_secondary_spam !== ""
				? this.model.client.email_secondary_spam : false;
		},
		pathToClient() {
			const role = this.$store.state.auth.role;
			if(role === "admin") {
				return "client";
			} else if(role === "manager") {
				return "clientM";
			} else if(role === 'supervisor') {
				return "clientM";
			}
		},
		websiteName() {
			return this.model.website || "---";
		},
		websitePartner() {
			if(this.model.websitePartner === 1) {
				return true;
			} else { 
				return false
			}
		},
		stagesList() {
			return this.stages && this.stages.length
				? this.stages
				: this.model.work_types
		}
	},
	methods: {
		enableEditing() {
			this.$emit("enableEditingOrder");
		},
		openComment() {
			this.$emit("showOrderComment");
		},
		openTask() {
			this.$emit("showOrderTask");
		},
		getDate(date) {
			return date ? date.split('-').reverse().join('.') : '';
		}
	}
}
</script>

<style lang="scss">
    .frsColorBackEmailSpam {
        background-color: #ce120c;
		color: white;
        padding: 5px;
        border-radius: 5px;
    }

    .frsColorBackSite {
        padding: 5px;
        border-radius: 5px;
    }

.order__details {
	width: 100%;
	border-spacing: 0;

	td {
		vertical-align: top;
	}

	tr > td:first-child {
		max-width: 45%;
		width: 45%;
		padding-right: 15px;
	}

	.top-border {
		column-span: 2;

		&__container {
			padding-top: 10px;
			padding-bottom: 15px;
		}

		&__line {
			border-top: 1px solid #e4e4e4;
		}
	}

	@media screen and (max-width: 500px) {
		tr > td:first-child {
			max-width: 50%;
			width: 50%;
		}
	}
}
</style>
